@let isErrorOccurred = errorNotificationService.isErrorOccurred$ | async;
@let learnBotId= botIdService.getBotId();

<mm-navigation [activeNavigation]="'chat'"></mm-navigation>
<div class="micromate-learn-component"
     [class.micromate-learn-component-dev-error]="isErrorOccurred !== null && isErrorOccurred !== undefined && isErrorOccurred === true">
    <div class="micromate-learn-context">
        <mm-chatbot
            *ngIf="(authUntilUserRoleService.assertLearner() | async) || (authUntilUserRoleService.assertAdmin() | async)"
            [botId]="learnBotId"></mm-chatbot>
    </div>
</div>
